import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { decrement, increment, remove } from "../redux/products/actions";

const CartCard = ({ item }) => {
  const dispatch = useDispatch();
  const { products } = useSelector((state) => state.products);
  const [selected, setSelected] = useState([]);
  const calculateItemTotal = item?.cartQuantity * item?.price;

  useEffect(() => {
    const selectedItem = products.filter((i) => i.id === item.id);
    setSelected(selectedItem);
  }, [products, item]);

  const handlePlus = () => {
    dispatch(increment(item));
  };
  const handleMinus = () => {
    dispatch(decrement(item));
  };
  const handleRemove = () => {
    dispatch(remove(item));
  };

  return (
    <div className="cartCard">
      <div className="flex items-center col-span-6 space-x-6">
        <img className="lws-cartImage" src={item?.imgUrl} alt="product" />

        <div className="space-y-2">
          <h4 className="lws-cartName">{item?.name}</h4>
          <p className="lws-cartCategory">{item?.category}</p>
          <p>
            BDT <span className="lws-cartPrice">{item?.price}</span>
          </p>
        </div>
      </div>
      <div className="flex items-center justify-center col-span-4 mt-4 space-x-8 md:mt-0">
        <div className="flex items-center space-x-4">
          <button
            onClick={handlePlus}
            disabled={selected[0]?.quantity === 0 && "disable"}
            className="lws-incrementQuantity"
          >
            <i className="text-lg fa-solid fa-plus"></i>
          </button>
          <span className="lws-cartQuantity">{item?.cartQuantity}</span>
          <button
            onClick={handleMinus}
            disabled={item?.cartQuantity <= 1 && "disable"}
            className="lws-decrementQuantity"
          >
            <i className="text-lg fa-solid fa-minus"></i>
          </button>
        </div>

        <p className="text-lg font-bold">
          BDT <span className="lws-calculatedPrice">{calculateItemTotal}</span>
        </p>
      </div>

      <div className="flex items-center justify-center col-span-2 mt-4 md:justify-end md:mt-0">
        <button onClick={handleRemove} className="lws-removeFromCart">
          <i className="text-lg text-red-400 fa-solid fa-trash"></i>
        </button>
      </div>
    </div>
  );
};

export default CartCard;
